import { render } from "./LicenseRow.vue?vue&type=template&id=3122193e&scoped=true"
import script from "./LicenseRow.vue?vue&type=script&lang=js"
export * from "./LicenseRow.vue?vue&type=script&lang=js"

import "./LicenseRow.vue?vue&type=style&index=0&id=3122193e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3122193e"]])

export default __exports__